import { useEffect, useState } from "react";

// Tone gradients keyed to project health. Bright leading edge → theme base color,
// plus a matching glow so the bar reads as "alive" rather than a flat block.
const TONES = {
  success: { from: "#34D399", to: "#10B981", glow: "rgba(16,185,129,.55)" },
  warning: { from: "#FBBF24", to: "#F59E0B", glow: "rgba(245,158,11,.55)" },
  error: { from: "#F87171", to: "#EF4444", glow: "rgba(239,68,68,.5)" },
};

const toneFor = (pct) => (pct >= 80 ? TONES.success : pct >= 40 ? TONES.warning : TONES.error);

/**
 * Animated progress bar — grows from 0 → pct on mount, gradient fill, glossy
 * top highlight and a periodic sheen sweep. Shared by the project card + detail.
 */
export default function ProgressBar({ pct = 0, height = 8 }) {
  const clamped = Math.min(100, Math.max(0, Math.round(pct)));
  const [w, setW] = useState(0);

  // Kick the width animation one frame after mount so the CSS transition runs.
  useEffect(() => {
    const id = requestAnimationFrame(() => setW(clamped));
    return () => cancelAnimationFrame(id);
  }, [clamped]);

  const t = toneFor(clamped);

  return (
    <div className="pbar" style={{ height }}>
      <div
        className="pbar-fill"
        style={{
          width: `${w}%`,
          background: `linear-gradient(90deg, ${t.from}, ${t.to})`,
          boxShadow: `0 0 10px ${t.glow}`,
        }}
      />
    </div>
  );
}
